import { fg } from '@atlassian/jira-feature-gating';

const JiraFyInvokeAgentExperimentAnalyticsRelayProvider = {
	get(): boolean {
		return fg('pack-2222-fyp-all-other-analytics');
	},
};

export default JiraFyInvokeAgentExperimentAnalyticsRelayProvider;
